import React from 'react'

import * as S from './styled'
import type { Props } from './types'

export const UnavailableResource = ({
  resource,
  description = 'Check the URL and try again.',
}: Props) => {
  return (
    <S.Container>
      <S.Title>There&apos;s no {resource} at this address.</S.Title>
      <S.Description>{description}</S.Description>
    </S.Container>
  )
}
